import React, { useEffect, useState } from 'react';
import { filter } from 'lodash';

import environmentService from '@lib/services/environment';

type EnvironmentABSConfig = {
  name: string;
  absToolHomepageUrl?: string;
  absToolApiUrl?: string;
};

const useABSToolConfigs = () => {
  const [listABSConfigs, setListABSConfigs] = useState<EnvironmentABSConfig[]>([]);

  useEffect(() => {
    const getEnv = async () => {
      const res = await environmentService.getEnvironments();
      if (res.ok) {
        const configsData = (res.data ?? []).map(
          ({
            name,
            config,
          }: {
            name: string;
            config?: { absToolHomepageUrl?: string; absToolApiUrl?: string };
          }) => ({
            name,
            absToolHomepageUrl: config?.absToolHomepageUrl,
            absToolApiUrl: config?.absToolApiUrl,
          }),
        );
        setListABSConfigs(
          filter(configsData, (data) => !!data?.absToolHomepageUrl && !!data?.absToolApiUrl),
        );
      }
    };

    getEnv();
  }, []);

  return { listABSConfigs };
};

export default useABSToolConfigs;
